import React from "react";
import { useField } from "formik";
import { TextField } from "@mui/material";

const CustomTextField = ({
  type,
  label,
  placeholder,
  InputProps,
  defaultValue,
  disabled,
  required = true, 
  ...props
}) => {
  const [field, meta] = useField(props);
  const errorText = meta.error && meta.touched ? meta.error : "";
  return (
    <TextField
      label={label}
      variant='outlined'
      required = {required}
      fullWidth
      type={type}
      placeholder={placeholder}
      defaultValue={defaultValue}
      disabled={disabled}
      {...field}
      helperText={errorText}
      error={!!errorText}
      InputProps={InputProps}
    />
  );
};

export default CustomTextField;
